module.exports = __webpack_public_path__ + "img/mobile-background_1.f8cd3827.webp";